import { PlanData, reduxPlanAction } from "../types";

export const updatePlan = (data: PlanData): reduxPlanAction => {
  return {
    type: "UPDATE_PLAN",
    payload: data,
  };
};
